









































import Vue from 'vue'

export default Vue.extend({
  methods: {
    handleLogout() {
      this.$auth.logout()
    },
  },
})
